module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAbCAMAAAC6CgRnAAAAXVBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////9RKvvlAAAAHnRSTlMAUPEJ17ughxDq5dObi358Xlc6HejjzMqieG5pRimp6sTEAAAA0klEQVQoz3SJVw7CQBQDX1t200ijF9//mFigBJBgPka2RhZ8bI+11cd2dPmmZMOC5fKZtEKcYB06wylQ6TttYYMHJoVOCB8M23dqZjmjFzbpcZa5WaKiKeK292fzvbmUhouUCmmzSQgKXPG6VWHr8JtOxC2ERqIVSic4HeYy4sI1oV9bj4m+YJQWM9cVt7XdcKVntHKohWTc13ZHFlIfZBdKEgY6I9MDkpLYieEf9hg+ffjsw+dOfP7DFy54whNfPOCJPzzxjie94ElnBNMnvnQNAGgqH2vGD5RIAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_earth.png
// module id = gysg
// module chunks = 1